module.exports = __webpack_public_path__ + "static/media/AnalyticsOverlay.1777b255.png";